<template>
    <div class="wrapper" >
        <div class="head_title">
            게임물 등급 검색
        </div>
        <div class="grade_wrapper">
             <swiper
                :slides-per-view="4"
                :space-between="0"
                :loop="false"                
                @swiper="onSwiper"
                @slideChange="onSlideChange"
            >   
                <swiper-slide>                  
                    <img src="https://www.grac.or.kr/resource/images/rating_all.gif" alt="">
                    <strong>전체이용가</strong>
                    <span>누구나 이용할 수 있는 게임물</span>
                </swiper-slide>  
                <swiper-slide>                  
                    <img src="https://www.grac.or.kr/resource/images/rating_12.gif" alt="">
                    <strong>12세이용가</strong>
                    <span>12세 미만은 이용할 수 없는 게임물</span>
                </swiper-slide>  
                <swiper-slide>                  
                    <img src="https://www.grac.or.kr/resource/images/rating_15.gif" alt="">
                    <strong>15세이용가</strong>
                    <span>15세 미만은 이용할 수 없는 게임물</span>           
                </swiper-slide>  
                <swiper-slide>                  
                    <img src="https://www.grac.or.kr/resource/images/rating_18.gif" alt="">
                    <strong>청소년 이용불가</strong>
                    <span>청소년은 이용할 수 없는 게임물</span>
                </swiper-slide> 
                <swiper-slide>                  
                    <img src="https://www.grac.or.kr/resource/images/icon_reject.gif" alt="">
                    <strong>등급분류거부</strong>
                    <span>등급분류 받을 수 없는 게임물</span>
                </swiper-slide>  
               
                <swiper-slide>                  
                    <img src="https://www.grac.or.kr/resource/images/icon_cancel1.gif" alt="">
                    <strong>등급분류결정취소예정</strong>
                    <span>등급필증이 취소예정인 게임물</span>
                </swiper-slide> 
                  <swiper-slide>                  
                    <img src="https://www.grac.or.kr/resource/images/icon_cancel2.gif" alt="">
                    <strong>등급분류결정취소</strong>
                    <span>등급필증이 취소된 게임물</span>
                </swiper-slide> 
            </swiper>           
        </div> 
        <div class="search_form">
            <div>
                <table>
                    <tr>
                        <th><input type="text" v-model="gametitle" placeholder="게임물명" @click="inputInit('gametitle')"></th>  
                        <th rowspan="3" style="border-left:1px solid #aeb0bd">
                            <div class="btn"><base-button @click="searchGrac()">검색</base-button></div>
                        </th>
                    </tr>    
                    <tr>
                        <th><input type="text" v-model="entname" placeholder="신청자(업체)명" @click="inputInit('entname')"></th>  
                    </tr>  
                    <tr>
                        <th><input type="text" v-model="rateno" placeholder="등급분류번호" @click="inputInit('rateno')"></th>  
                    </tr>                               
                </table>
            </div>         
        </div>
        <div class="search_result">                
            <div class= "search_block_wrap" v-html="gracResult" v-if="gracResult && !isLoading">
                
            </div>
            <div v-else>
                내용을 입력하고 검색을 클릭해 주세요   
            </div>
            <div v-if="gracResult && !isLoading">
                <span class="search_close" @click="hideResult">접기</span>
            </div>
            <div class="loading-spinner" v-if="isLoading">
                <base-spinner></base-spinner>
            </div>           
            
        </div>    
      
    </div>  
    
</template>

<script>
  // import Swiper core and required modules
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper';
  // Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);
import axios from "axios";
export default {
    name:'GracSeach',
    data(){
        return{
            gracResult:'',
            gametitle:'',
            entname:'',
            rateno:'',
            isLoading:false
        }
    },
    components:{
        Swiper,
        SwiperSlide,
    },
    // mounted() {
    //     document.addEventListener('scroll', this.handleScroll);
    // },
    // unmounted() {
    //     document.removeEventListener('scroll', this.handleScroll);
    // },
    methods:{
        
        hideResult(){
            this.gracResult = "";    
        },
        inputInit(input){
            this[input] ="";    
        },
        async searchGrac() {
            if(this.gametitle =='' && this.entname =='' && this.rateno ==''   )
            {
                this.gametitle ='[게임물명]';
            }
            this.isLoading = true;        
            const response = await axios.get("http://www.grac.or.kr/WebService/GameSearchSvc.asmx/game",{
                params:{
                    gametitle:this.gametitle, display:100, pageno:1, entname:this.entname, rateno:this.rateno
                    }
                })      
            console.log(response);
            this.isLoading = false;      
            this.parsing(response);
             
            
        },
        //게등위 xml 파싱
        parsing(data){      
            const xml = data.request.responseXML;
            let itemNodes = xml.getElementsByTagName('item');
            let output ="";
            
            for(let i =0; i < itemNodes.length; i++)
            {
                let itemNode  = itemNodes[i];
                let gametitle = itemNode.children[0].childNodes.length>0?itemNode.children[0].childNodes[0].data:'';
                let orgname   = itemNode.children[1].childNodes.length>0?itemNode.children[1].childNodes[0].data:'';
                let entname   = itemNode.children[2].childNodes.length>0?itemNode.children[2].childNodes[0].data:'';
                //let hoperate  = itemNode.children[3].childNodes.length>0?itemNode.children[3].childNodes[0].data:'';
                let givenrate = itemNode.children[4].childNodes.length>0?itemNode.children[4].childNodes[0].data:'';
                let rateno    = itemNode.children[5].childNodes.length>0?itemNode.children[5].childNodes[0].data:'';
                let rateddate = itemNode.children[6].childNodes.length>0?itemNode.children[6].childNodes[0].data:'';
                //console.log(gametitle,orgname,entname,hoperate,givenrate,rateno,rateddate);
                output += "<div style='border:1px solid #ccc;border-radius:5px;margin-bottom:10px;'>";               
                output += " <div style='font-weight:bold;background:rgb(121, 180, 151);padding:5px;text-align:center'>"+gametitle+"</div>";
                output += " <div style='font-weight:bold;background:#eee;padding:5px;text-align:center'>등급분류기관</div>";
                output += " <div>"+orgname+"</div>";
                output += " <div style='font-weight:bold;background:#eee;padding:5px;text-align:center;margin-top:10px'>회사이름</div>";
                output += " <div>"+entname+"</div>"; 
                output += " <div style='font-weight:bold;background:#eee;padding:5px;text-align:center;margin-top:10px'>결정등급</div>";              
                output += " <div>"+givenrate+"</div>";
                output += " <div style='font-weight:bold;background:#eee;padding:5px;text-align:center;margin-top:10px'>등급분류번호</div>";  
                output += " <div>"+rateno+"</div>";
                output += " <div style='font-weight:bold;background:#eee;padding:5px;text-align:center;margin-top:10px'>등급분류일자</div>"; 
                output += " <div>"+rateddate+"</div>";  
                output += "</div>";                   
            }
                 
           
            this.gracResult = output;      
        }
    }
}
</script>
<style lang="scss" scoped>

.wrapper{
    background:#fff;
    padding:20px;   
    .head_title{
        font-size:18px;
        font-weight:bold;
        color:#000;
        margin-bottom:10px;
        text-align: left;
    }
     table{
            width:100%;
            border:1px solid #aeb0bd;  
            border-collapse: collapse;
            font-size:12px;
            tr{    
                border-bottom:1px solid #aeb0bd;    
            }
            th{
                background: #eee;
                line-height: 30px;
                font-size:14px;                
            }
            td{    
                line-height: 30px;
                
            }
        }        
    .grade_wrapper{
        margin-top: 0;
        padding-top: 15px; 
        margin-bottom: 10px;    
        border: 1px solid #aeb0bd;  
        border-radius: 3px;  
        
               
        .swiper-slide{
            height: 120px;
            display: flex;
            justify-content: start;
            align-items:center;
            flex-direction:column;
            border-left: 1px solid #eee;
            padding: 0 5px;            
            img{
                height:30px;
            }
            strong{
                margin: 10px 0;
                font-size: 12px;
                white-space:nowrap;
            }    
            span{
                font-size:11px;
            }
        }
       
       
      
    }
    .search_form{
        table{
            input{    
                border:1px solid #aeb0bd;
                padding-left:10px;
                line-height:20px;
            }
                td{
                text-align:center;
            }
        } 
        .btn{   
            line-height:20px !important;
            padding:10px 0 ;
        }
    }      
    .search_result{
        margin-top:10px;        
        .search_close{
            padding:5px 0;
            background:#f1f1f1;
            border: 1px solid #aeb0bd;
            display: block;
            border-bottom-left-radius:5px;
            border-bottom-right-radius: 5px;
        }
        
       
    }   
}






</style>